import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Platform } from '@ionic/angular';
import { HTTP } from '@ionic-native/http/ngx';
import { environment } from 'src/environments/environment';
import { Marcaje } from '../interfaces/marcaje';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
@Injectable({
  providedIn: 'root'
})
export class ServiciosService {

  id_plataforma: string;
  empresa: string;
  telefono: String;
  token: String;
  // ruta: String = 'http://192.168.1.48:8080/Marcajes/ControladorMarcajes?api_key='+environment.api_key;
  ruta: String = `${environment.wsBaseUrl}?api_key=${environment.api_key}`;
  rutaSinNada: String = `${environment.wsBaseUrlRaiz}`;
  private rutaAltWs = environment.rutaAltWS;

  constructor(private http: HttpClient,
              public plt: Platform,
              private httpmovil: HTTP,
              private iab: InAppBrowser) {
   }
  // getLogueo(telefono: String, password: String) {
  //   let parametros = {
  //     'telefono' : telefono,
  //     'pass' : password
  //   };

  //   let headers = new HttpHeaders().set('Content-Type', 'application/json');

  //   //let body =  JSON.stringify(parametros);

  //   return this.http.post('http://controltiempoapk.g2k.es/Marcajes/ControladorMarcajes', parametros, { headers:headers });

  // }

// controltiempoapk.g2k.es

  getLogin(telefono: String, password: String, version: string) {
    return this.http.get(this.ruta+'&telefono=' + telefono + '&password=' + password + '&servicio=login');
  }
  getMotivos() {

    const params = this.cargarParams();
    return this.http.get(this.ruta + '&servicio=getMotivos' + params);
  }
  getMarcaje(telefono: string, id: number) {

    const params = this.cargarParams();
    return this.http.get(this.ruta + params + '&id=' + id + '&servicio=getMarcaje');
  }

  getDatosEmpresas(empresa: string) {

    const params = this.cargarParams(empresa);
    return this.http.get(this.ruta + params + '&servicio=getDatosEmpresa');
  }

  setInsertaMarcaje(marcaje: Marcaje, borrado: boolean, datos_equipo: string, e_s: string, redes: string, latitud: string,
                    longitud: string,datosIniciales: number ) {

    const fecha_marcaje = new Date(marcaje.fecha_time).getTime();
    if (datos_equipo == null || datos_equipo === '') {
      datos_equipo = 'Web';
    }
    let entrada = 0;
    let salida = 0;
    let finalizar_jornada = 0;
    let params = '';
    if(marcaje.empresa){
      params = this.cargarParams(marcaje.empresa);
    } else {
      params = this.cargarParams();
    }
    if (marcaje.entrada !== undefined && marcaje.entrada != null ) {
      entrada = marcaje.entrada;
    }
    if (marcaje.salida !== undefined && marcaje.salida != null) {
      salida = marcaje.salida;
    }
    if (marcaje.finalizar_jornada !== undefined && marcaje.finalizar_jornada != null) {
      finalizar_jornada = marcaje.finalizar_jornada;
    }
    return this.http.get(this.ruta + '&servicio=setInsertaMarcaje'
      + '&id=' + marcaje.id + '&empleado=' + marcaje.empleado + '&datosIniciales=' + datosIniciales
      + '&fecha_marcaje=' + fecha_marcaje + '&codigo_motivo=' + marcaje.codigoMotivo
      + '&borrado=' + borrado
      + '&datos_equipo=' + datos_equipo + '&tipo=' + e_s + '&sincronizar=0&redes=' + redes + '&latitud=' + latitud
      + '&longitud=' + longitud + '&entrada=' + entrada + '&salida=' + salida
      + '&finalizar_jornada=' + finalizar_jornada + params);
  }
  setFinalizaJornada(marcaje: any, borrado: boolean, datos_equipo: string, e_s: string, redes: string, latitud: string,
                     longitud: string) {

    const fecha_marcaje = new Date(marcaje.fecha_time).getTime();
    if (datos_equipo == null || datos_equipo === '') {
      datos_equipo = 'Web';
    }
    const params = this.cargarParams();
    return this.http.get(this.ruta + '&servicio=setFinalizaJornada'
      + '&id=' + marcaje.id + '&empleado=' + marcaje.empleado
      + '&fecha_marcaje=' + fecha_marcaje + '&codigo_motivo=' + marcaje.codigoMotivo
      + '&borrado=' + borrado
      + '&datos_equipo=' + datos_equipo + '&tipo=' + e_s + '&sincronizar=0&redes=' + redes + '&latitud=' + latitud
      + '&longitud=' + longitud + params);

  }
  getHistorico(empleado: number, telefono: String, pagina: number,empresa?: number) {
    let params: string;
    if(empresa){
      params = this.cargarParams(empresa);
    } else {
      params = this.cargarParams();
    }
    return this.http.get(this.ruta + '&servicio=getHistorico&pagina=' + pagina + '&empleado=' + empleado + params);
  }
  setCambiaPassword(password: string, latitud: string, longitud: string, redes: string, id_plataforma: string) {

    const telefono = localStorage.getItem('telefono');
    const fecha_actual = new Date().getTime();
    const dispositivo = this.plt.platforms();
    const params = this.cargarParams();
    return this.http.get(this.ruta + '&servicio=setCambiaPassword&password=' + password +
      '&dispositivo=' + dispositivo + '&sincronizar=1&latitud=' + latitud
      + '&longitud=' + longitud + '&redes=' + redes + params);
  }
  setCambiaTelefono(telefono: string, latitud: string, longitud: string, redes: string) {

    const fecha_actual = new Date().getTime();
    const dispositivo = this.plt.platforms();
    const params = this.cargarParams();
    return this.http.get(this.ruta+'&servicio=setCambiaTelefono&telefono_new=' + telefono + '&fecha=' + fecha_actual
      + '&dispositivo=' + dispositivo + '&sincronizar=1&latitud=' + latitud + '&redes=' + redes +
      + '&longitud=' + longitud + params);
  }

  setEliminaMarcaje(telefono: String, latitud: String, longitud: String, wifisconcat: String, datos: String, id: number, id_plat_orig: number,tipo: number) {

    const params = this.cargarParams();
    return this.http.get(this.ruta+'&servicio=setEliminaMarcaje&sincronizar=1&latitud='+ latitud+'&longitud='+longitud+
                        '&wifis='+wifisconcat+'&datos='+datos+'&id=' + id + '&id_plat_orig=' + id_plat_orig + '&tipo=' + tipo + params);
  }
  setRecuperaPassword(telefono: string, nuevoPass: string, usuario: string) {

    const params = this.cargarParams();
    return this.http.get(this.ruta + params +
      '&sincronizar=0' + '&servicio=setEnvios&tipo=RECUPERA_PASSWORD&n2=' + nuevoPass + '&n1=' + usuario);
  }
  setCambioPassword(telefono: string, usuario: string) {

    const params = this.cargarParams();
    return this.http.get(this.ruta + params +
                        '&sincronizar=0' + '&servicio=setEnvios&tipo=CAMBIO_PASSWORD&n1=' + usuario );
  }
  setCambioTelefono(telefono: string, usuario: string) {

    const params = this.cargarParams();
    return this.http.get(this.ruta + params +
      '&sincronizar=0' + '&servicio=setEnvios&tipo=CAMBIO_TELEFONO&n1=' + usuario + '&n2=' + telefono);
  }
  // getFechaReal() {
  //   return this.http.get('https://www.sede.fnmt.gob.es/delegate/fechaoficial');
  // }
  getConfiguracion(plataforma: string) {

    return this.http.get(this.ruta + '&servicio=getConfiguracion&telefono=' + localStorage.getItem('telefono'));
  }
  setRenuevaSession(telefono: String, token: String) {
    return this.http.get(this.ruta + '&servicio=renuevaSesion&telefono=' + localStorage.getItem('telefono') + '&token=' + sessionStorage.getItem('token'));
  }
  setFechaReal() {

      this.httpmovil.get('https://www.sede.fnmt.gob.es/delegate/fechaoficial', {}, {})
        .then(data => {
          localStorage.setItem('fecha_real', data.data);
        })
        .catch(error => {
          localStorage.setItem('fecha_real', '"millis":' + new Date());
        });
  }
  setFechaAhora() {
    return this.httpmovil.get('https://www.sede.fnmt.gob.es/delegate/fechaoficial', {}, {});
  }
  setFechaAhoraSecundaria() {
    return this.httpmovil.get('https://worldtimeapi.org/api/timezone/Europe/Madrid', {}, {});
  }

  // https://www.sede.fnmt.gob.es/delegate/fechaoficial
  cargarParams(empresa?: any) {
    this.id_plataforma = localStorage.getItem('id_plataforma');
    this.empresa = empresa || localStorage.getItem('empresa_cloud');
    this.telefono = localStorage.getItem('telefono');
    this.token = sessionStorage.getItem('token');
    return '&empresa=' + this.empresa + '&id_plataforma=' + this.id_plataforma + '&telefono=' + this.telefono + '&token=' + this.token;
  }
  abrirAyuda() {
    this.iab.create(environment.personalizado.enlaceAyuda, '_system');
  }


  public dameEmpleados() {
    return this.http.get(this.rutaSinNada + '/ControladorEmpleados');
  }

  public pruebaConexionServidor() {
    return this.http.get(this.rutaSinNada + '/ControladorLogin');
  }

  public suscribNotificaciones(suscripcion) {
    const formData = new FormData();
    formData.append('suscripcion', JSON.stringify(suscripcion));
    return this.http.post(`${this.rutaAltWs}/servicios/registra/suscripcion`,formData);
  }
}

